import api from "../middlware/api";
import { BASE_URL } from "../constants";
import { camelToSnake } from "../utils/CamelToSnake";
import { POSSale, PharmacyBatch } from "../interfaces/POS";

// Create a new POS sale
// Payload should be in backend format (snake_case) as per StorePharmacySaleRequest validation
export const createPOSSale = (payload: any) => {
  return new Promise((resolve, reject) => {
    api
      .post(`${BASE_URL}/api/v1/pharmacy-sales`, payload)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

// Get POS sales list
export const getPOSSales = (params?: any) => {
  return new Promise((resolve, reject) => {
    let query = new URLSearchParams();
    if (params) {
      for (let key in params) {
        if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
          query.set(key, params[key]);
        }
      }
    }
    const queryString = query.toString();
    const url = queryString 
      ? `${BASE_URL}/api/v1/pharmacy-sales?${queryString}`
      : `${BASE_URL}/api/v1/pharmacy-sales`;
    
    api
      .get(url)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

// Get POS sale by ID
export const getPOSSaleById = (id: number) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/pharmacy-sales/${id}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

// Update POS sale
export const updatePOSSale = (id: number, payload: Partial<POSSale>) => {
  return new Promise((resolve, reject) => {
    api
      .put(`${BASE_URL}/api/v1/pharmacy-sales/${id}`, camelToSnake(payload))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

// Cancel POS sale
export const cancelPOSSale = (id: number) => {
  return new Promise((resolve, reject) => {
    api
      .put(`${BASE_URL}/api/v1/pharmacy-sales/${id}/cancel`, {})
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

// Update delivery status for a POS sale
export const updatePOSDeliveryStatus = (
  id: number,
  deliveryStatus: "pending" | "dispatched" | "received" | "completed" | "rejected"
) => {
  return new Promise((resolve, reject) => {
    api
      .patch(
        `${BASE_URL}/api/v1/pharmacy-sales/${id}/delivery-status`,
        { delivery_status: deliveryStatus }
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

// Get batches for a pharmacy item
export const getPharmacyItemBatches = (pharmacyItemId: number) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/pharmacy-items/${pharmacyItemId}/batches`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

















